import QuestionEdit from './QuestionEdit.vue'
import QuestionsComponent from './QuestionsComponent.vue'

export default {
	QuestionEdit,
	QuestionsComponent,
}